"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgWifi = function SvgWifi(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M8 14a1 1 0 110-2 1 1 0 010 2zm-1.928-2.68a1 1 0 11-1.144-1.64C6.063 8.89 6.905 8.5 8 8.5c1.12 0 2.062.424 3.099 1.2A1 1 0 119.9 11.3C9.18 10.76 8.6 10.5 8 10.5c-.57 0-1.107.248-1.928.82zm7.562-4.094a1 1 0 11-1.268 1.548C10.97 7.63 9.5 7 8 7c-1.623 0-3.109.552-4.366 1.582a1 1 0 11-1.268-1.547C3.975 5.717 5.906 5 8 5c2.012 0 3.907.812 5.634 2.226zM1.642 5.767A1 1 0 11.358 4.233C2.66 2.307 4.888 1.5 8 1.5s5.34.807 7.642 2.733a1 1 0 01-1.284 1.534C12.417 4.143 10.643 3.5 8 3.5s-4.417.643-6.358 2.267z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

SvgWifi.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgWifi;
exports.default = _default;